import { Injectable, signal } from '@angular/core';
import { NodeKind } from '../nodes/moulding-node-registry';

export type MouldingNodeDialog = {
  nodeId: string;
  nodeKind: NodeKind;
};

@Injectable()
export class MouldingNodeDialogService {
  readonly activeDialog = signal<MouldingNodeDialog | null>(null);

  open(nodeId: string, nodeKind: NodeKind): void {
    this.activeDialog.set({ nodeId, nodeKind });
  }

  close(): void {
    this.activeDialog.set(null);
  }
}
